import Layout from "../Frames/Layout"
import Chart from "./Chart"
import Kpis from "./Kpis"
import { Stack } from "@mui/material"
import { useState, useEffect } from "react"
import API from "../../services/API"
import Loader from "../Tools/Loader"
import Courses from "./Courses"
import Stickers from "./Stickers"

export default function Dashboard(){

    const [courses, setCourses] = useState(null)

    useEffect(() => {

        API.get('/teachers/me/stats')
            .then(r => setCourses(r.data))

    }, [])

    return <Layout tab='teacher' menu='main' title='Espace Formateur'>

        {courses && 
            <Stack spacing={3}>

                <Kpis courses={courses} />

                <Chart courses={courses} />

                <Courses courses={courses} />

                <Stickers /> 

            </Stack>
        }

        {!courses && <Loader />}

    </Layout>
}